module.exports = __webpack_public_path__ + "img/passport-front-illustration.d006400e.png";